import React from "react";
import { styled } from "@mui/material/styles";
import { Typography, Box } from "@mui/material";

import MapInfoIcon from "./mapInfo/MapInfoIcon";

const SidebarHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-start",
}));

const SidebarDesktopHeader = () => {
  return (
    <SidebarHeader>
      <Typography variant="h1" component="h1" sx={{ lineHeight: "1" }}>
        London High Streets Map Explorer
      </Typography>
      <MapInfoIcon />
    </SidebarHeader>
  );
};

export default SidebarDesktopHeader;
